var _rect, _path, _path2, _g, _g2, _g3, _path3, _path4, _path5, _path6, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlat1000Off(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 200,
    viewBox: "0 0 800 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    rx: 10,
    fill: "#ECEFF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30 L800 30",
    stroke: "#607D8B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 170 L800 170",
    stroke: "#607D8B",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(70, 100)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 40,
    fill: "none",
    stroke: "#607D8B",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 30,
    fill: "none",
    stroke: "#607D8B",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 20,
    fill: "none",
    stroke: "#607D8B",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50 0 L50 0",
    stroke: "#607D8B",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -50 L0 50",
    stroke: "#607D8B",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-35 -35 L35 35",
    stroke: "#607D8B",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 -35 L-35 35",
    stroke: "#607D8B",
    strokeWidth: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(730, 100)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 40,
    fill: "none",
    stroke: "#607D8B",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 30,
    fill: "none",
    stroke: "#607D8B",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 20,
    fill: "none",
    stroke: "#607D8B",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50 0 L50 0",
    stroke: "#607D8B",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -50 L0 50",
    stroke: "#607D8B",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-35 -35 L35 35",
    stroke: "#607D8B",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 -35 L-35 35",
    stroke: "#607D8B",
    strokeWidth: 1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(650, 60)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 25,
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 20,
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    fontWeight: "bold",
    fill: "white",
    textAnchor: "middle"
  }, "PREMIUM"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150 140 C170 120, 190 150, 210 130",
    stroke: "#607D8B",
    strokeWidth: 2,
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150 130 C170 110, 190 140, 210 120",
    stroke: "#607D8B",
    strokeWidth: 2,
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M590 140 C570 120, 550 150, 530 130",
    stroke: "#607D8B",
    strokeWidth: 2,
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M590 130 C570 110, 550 140, 530 120",
    stroke: "#607D8B",
    strokeWidth: 2,
    fill: "none"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 80,
    fontFamily: "Arial, sans-serif",
    fontSize: 40,
    fontWeight: "bold",
    fill: "#455A64",
    textAnchor: "middle"
  }, "FLAT \u20B91000 OFF")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 120,
    fontFamily: "Arial, sans-serif",
    fontSize: 20,
    fill: "#455A64",
    textAnchor: "middle"
  }, "Premium Customer Discount")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 150,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#607D8B",
    textAnchor: "middle"
  }, "Limited time offer for orders above \u20B910,000")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlat1000Off);
export default __webpack_public_path__ + "static/media/flat_1000_off.5c78fe36a75cc6c5fc2f3f4ae6061139.svg";
export { ForwardRef as ReactComponent };